export default {
  arl: '0',
  arc: '1',
  arp: '2',
  arm: '3',
  pdf: '4',
};



// WEBPACK FOOTER //
// ./src/constants/documentTypes.js